var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "divBox" }, [
    _c(
      "div",
      [
        _c("el-card", { staticClass: "normal-page" }, [
          _c(
            "div",
            [
              _c("div", { staticClass: "flex-between" }, [
                _c("div", { staticClass: "text-right" }, [
                  _c(
                    "div",
                    { staticClass: "title-16" },
                    [
                      _vm._v("\n              职级体系图\n              "),
                      _c(
                        "el-popover",
                        {
                          attrs: {
                            placement: "right",
                            trigger: "hover",
                            "popper-class": "monitor-yt-popover",
                          },
                        },
                        [
                          _c("div", { staticClass: "prompt-bag" }, [
                            _vm._v(
                              "点击职级或职等对应的格子，可进行添加或移除等操作"
                            ),
                          ]),
                          _vm._v(" "),
                          _c("i", {
                            staticClass: "el-icon-question",
                            attrs: { slot: "reference" },
                            slot: "reference",
                          }),
                        ]
                      ),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "flex lh-center" },
                  [
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "hasPermi",
                            rawName: "v-hasPermi",
                            value: [
                              "hr:enterprise:job:positionSystemChart:add",
                            ],
                            expression:
                              "['hr:enterprise:job:positionSystemChart:add']",
                          },
                        ],
                        staticClass: "mr10 h32",
                        attrs: {
                          type: "primary",
                          size: "small",
                          icon: "el-icon-plus",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.addLevel(1)
                          },
                        },
                      },
                      [_vm._v("添加职等")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-dropdown",
                      [
                        _c("span", {
                          staticClass: "iconfont icongengduo2 pointer",
                        }),
                        _vm._v(" "),
                        _c(
                          "el-dropdown-menu",
                          { staticStyle: { "text-align": "left" } },
                          [
                            _c(
                              "el-dropdown-item",
                              {
                                nativeOn: {
                                  click: function ($event) {
                                    return _vm.addLevel(2)
                                  },
                                },
                              },
                              [_vm._v(" 批量修改职等区间 ")]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "rank-right v-height-flag" }, [
                _c("div", { staticClass: "table-box mt14" }, [
                  _vm.tableData.length > 0
                    ? _c(
                        "div",
                        {
                          directives: [{ name: "height", rawName: "v-height" }],
                        },
                        [
                          _c(
                            "el-table",
                            {
                              attrs: {
                                data: _vm.tableData,
                                border: "",
                                "row-key": "id",
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  prop: "salary",
                                  label: "薪资范围",
                                  width: "120",
                                  fixed: "left",
                                },
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "rankMax",
                                  label: "职等",
                                  width: "80",
                                  fixed: "left",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c(
                                            "el-popover",
                                            {
                                              ref: "pop-" + scope.row.$index,
                                              attrs: {
                                                placement: "bottom-end",
                                                trigger: "click",
                                                offset: 10,
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "right-item-list",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "right-item",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          $event.stopPropagation()
                                                          return _vm.editLevel(
                                                            1,
                                                            scope.row
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [_vm._v("编辑职等")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "right-item",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          $event.stopPropagation()
                                                          return _vm.deleteLevel(
                                                            scope.row
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [_vm._v("删除职等")]
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "default-color rank-title",
                                                  attrs: { slot: "reference" },
                                                  slot: "reference",
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        scope.row.min_level
                                                      )
                                                    ),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("span", [_vm._v("-")]),
                                                  _vm._v(" "),
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        scope.row.max_level
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  2091868501
                                ),
                              }),
                              _vm._v(" "),
                              _vm._l(_vm.tableHeader, function (info) {
                                return _c(
                                  "div",
                                  { key: info.id },
                                  [
                                    _c("el-table-column", {
                                      attrs: { label: "职级", width: "110px" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (scope) {
                                              return [
                                                _c(
                                                  "div",
                                                  {
                                                    on: {
                                                      click: function ($event) {
                                                        $event.stopPropagation()
                                                        return _vm.addRankColumn(
                                                          $event,
                                                          scope.row,
                                                          info.id
                                                        )
                                                      },
                                                    },
                                                  },
                                                  _vm._l(
                                                    scope.row.info,
                                                    function (item) {
                                                      return _c(
                                                        "div",
                                                        {
                                                          directives: [
                                                            {
                                                              name: "show",
                                                              rawName: "v-show",
                                                              value:
                                                                info.id ===
                                                                item.id,
                                                              expression:
                                                                "info.id === item.id",
                                                            },
                                                          ],
                                                          key: "rank" + item.id,
                                                          staticClass:
                                                            "pointer",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                          " +
                                                              _vm._s(
                                                                item.info &&
                                                                  item.info.rank
                                                                  ? item.info
                                                                      .rank
                                                                      .alias +
                                                                      " (" +
                                                                      item.info
                                                                        .rank
                                                                        .name +
                                                                      ")"
                                                                  : ""
                                                              ) +
                                                              "\n                        "
                                                          ),
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  0
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: { label: info.name },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (scope) {
                                              return _vm._l(
                                                scope.row.info,
                                                function (item) {
                                                  return _c(
                                                    "div",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "show",
                                                          rawName: "v-show",
                                                          value:
                                                            info.id === item.id,
                                                          expression:
                                                            "info.id === item.id",
                                                        },
                                                      ],
                                                      key: item.id,
                                                    },
                                                    [
                                                      item.info &&
                                                      item.info.job.length > 0
                                                        ? _c(
                                                            "span",
                                                            _vm._l(
                                                              item.info.job,
                                                              function (
                                                                col,
                                                                index
                                                              ) {
                                                                return _c(
                                                                  "span",
                                                                  {
                                                                    key: index,
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                            " +
                                                                        _vm._s(
                                                                          col.name
                                                                        ) +
                                                                        "\n                            " +
                                                                        _vm._s(
                                                                          item
                                                                            .info
                                                                            .job
                                                                            .length -
                                                                            1 !==
                                                                            index
                                                                            ? "、"
                                                                            : ""
                                                                        ) +
                                                                        "\n                          "
                                                                    ),
                                                                  ]
                                                                )
                                                              }
                                                            ),
                                                            0
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  )
                                                }
                                              )
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                )
                              }),
                            ],
                            2
                          ),
                        ],
                        1
                      )
                    : _c(
                        "div",
                        [
                          _c("default-page", {
                            directives: [
                              { name: "height", rawName: "v-height" },
                            ],
                            attrs: { index: 13, "min-height": 520 },
                          }),
                        ],
                        1
                      ),
                ]),
              ]),
              _vm._v(" "),
              _c("rank-dialog", {
                ref: "rankDialog",
                attrs: { config: _vm.config },
                on: {
                  isOk: function ($event) {
                    return _vm.getTableData()
                  },
                },
              }),
              _vm._v(" "),
              _c("right-click", {
                ref: "rightClick",
                attrs: { "config-data": _vm.configData },
                on: { handleRightClick: _vm.handleRightClick },
              }),
            ],
            1
          ),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }